import React from 'react';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import {
  CheckoutFormProps,
  DefaultFormActions,
  Form,
  useEnhancedForm,
} from '../../apiForm/form';
import { SelectField, TextField } from '../../apiForm/form/input';
import ArrayWrapper from '../../apiForm/wrapper/ArrayWrapper';
import ExpandableFieldset from '../../apiForm/form/ExpandableFieldset';

export default function DiscountReasonsForm({
  defaultValues = {},
  errors = {},
  onSubmit,
  readonly,
}: CheckoutFormProps<any>) {
  const { t } = useTranslation();
  const { handleSubmit, control, formState, getValues, reset } =
    useEnhancedForm({ defaultValues, errors });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <ExpandableFieldset category="discountReasons">
        <ArrayWrapper
          control={control}
          name="discountReasons"
          defaultValue={{}}
          addLabel={t('checkoutConfig.arrayWrapper.discountReason.add')}
          removeLabel={t('checkoutConfig.arrayWrapper.discountReason.remove')}
          render={(index: number) => (
            <Stack spacing={1}>
              <SelectField
                control={control}
                name={`discountReasons[${index}].method`}
                disabled={readonly}
                label={t('checkoutConfig.label.discount.method')}
              >
                <MenuItem value="priceOverwrite">priceOverwrite</MenuItem>
                <MenuItem value="basePriceOverwrite">
                  basePriceOverwrite
                </MenuItem>
                <MenuItem value="priceEntry">priceEntry</MenuItem>
                <MenuItem value="manualCartDiscount">
                  manualCartDiscount
                </MenuItem>
                <MenuItem value="manualLineItemDiscount">
                  manualLineItemDiscount
                </MenuItem>
              </SelectField>
              <TextField
                control={control}
                name={`discountReasons[${index}].code`}
                disabled={readonly}
                label={t('checkoutConfig.label.discount.code')}
              />
              <TextField
                control={control}
                name={`discountReasons[${index}].message`}
                disabled={readonly}
                label={t('checkoutConfig.label.discount.message')}
              />
            </Stack>
          )}
        />
      </ExpandableFieldset>

      <DefaultFormActions
        formState={formState}
        cancelNavigationTarget="/"
        noCancelNavigation
        reset={reset}
        getValues={getValues}
      />
    </Form>
  );
}
